export const alertsRoutes = (root: string) => ({
  root,
  view: () => {
    return `${root}/view/:alertId`;
  },
  /** @deprecated Legacy path only for redirects, use events routes instead. */
  legacyEventView: () => `${root}/events/:id`,
});
